import { render } from "./AuditDetail.vue?vue&type=template&id=c8ca75be"
import script from "./AuditDetail.vue?vue&type=script&lang=js"
export * from "./AuditDetail.vue?vue&type=script&lang=js"

import "./AuditDetail.vue?vue&type=style&index=0&id=c8ca75be&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__